import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CacheInterceptor implements HttpInterceptor {

  public cacheStorage: Cache;

  constructor() {
    if ('caches' in window) {
      caches.open('administrativotodomas').then((res) => (this.cacheStorage = res));
    }
  }

  // eslint-disable-next-line
  async put(req: string, body: any) {
    body = JSON.stringify(body);
    const response = new Response(body, {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
    return await this.cacheStorage.put(req, response);
  }

  async get(req: string): Promise<HttpResponse<any>> {
    const response: Response = await this.cacheStorage.match(req);

    if (!response) {
      throw Error('response not found');
    }

    const body = await response.json();

    return new HttpResponse({ body, status: 200, statusText: 'ok' });
  }


  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const useCache = req.params.get('_useCache');

    // remove interceptor params from request req =
    req.clone({
      params: req.params.delete('_useCache'),
    });

    // make sure that this browser support caches
    if (!('caches' in window)) {
      return next.handle(req);
    }

    const cacheRequest = req.urlWithParams;

    const observable = next.handle(req).pipe(
      tap((res: HttpResponse<any>) => {
        if (res instanceof HttpResponse && useCache) {
          this.put(cacheRequest, res.body);
        }
      })
    );

    if (useCache) {
      return from(this.get(cacheRequest)).pipe(catchError((_) => observable));
    }

    return observable;
  }
}


